import React from 'react';
import {compose, graphql} from 'react-apollo';

import {Card, Input, Button} from 'ui-kit';
import {FormFooter} from '../../../FormFooter';

import * as styles from './SubdomainForm.module.css';
import gql from 'graphql-tag';

class SubdomainForm extends React.Component {
  state = {
    formVisible: this.props.initialSubdomain == null,
    subdomain: this.props.initialSubdomain || '',
    status: null, // null | loading | success
    errors: {},
  };

  render() {
    const {initialSubdomain} = this.props;
    const {formVisible, subdomain, status, errors} = this.state;

    const formMarkup = (
      <form method="POST" onSubmit={this.handleSubmit}>
        <div className={styles.DomainContainer}>
          <div className={styles.DomainInput}>
            <Input
              style={{fontFamily: 'monospace', textAlign: 'right'}}
              onChange={this.handleInputChange}
              value={subdomain}
              name="subdomain"
              errorMessage={errors.subdomain}
            />
          </div>
          <div className={styles.DomainText}>.paywithplum.com</div>
        </div>

        <FormFooter status={status} />
      </form>
    );

    let content;
    if (initialSubdomain == null) {
      content = (
        <>
          <p>
            You do not currently have a subdomain. Your subdomain will be
            visible to patients, so it should be associated with your practice
            to gain their trust.
          </p>

          {formMarkup}
        </>
      );
    } else if (formVisible) {
      content = (
        <>
          <p>
            Once changed, your old subdomain will stop working. Be thoughtful of
            how changing your subdomain may impact your patients.
          </p>

          {formMarkup}
        </>
      );
    } else {
      content = (
        <>
          <p>
            Your patients can currently sign up for your membership plan at the
            following URL:
          </p>

          <div className={styles.Url}>
            <pre>https://{subdomain}.paywithplum.com</pre>
          </div>

          <p className={styles.WarningText}>
            You may change your subdomain my clicking below. Remember that
            changes to subdomains are permanent and may impact your patients.
          </p>

          <Button color="light" onClick={this.showForm}>
            I understand, change domain
          </Button>
        </>
      );
    }

    return <Card>{content}</Card>;
  }

  handleInputChange = event => {
    const {name, value} = event.target;

    this.setState({[name]: value});
  };

  showForm = () => {
    this.setState({formVisible: true});
  };

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({status: 'loading'});

    const {mutate} = this.props;
    const {subdomain} = this.state;

    const {data} = await mutate({variables: {input: {subdomain}}});
    const {errors} = data.updatePractice;

    if (errors.length > 0) {
      console.log(errors);
      this.setState({
        status: null,
        errors: {subdomain: 'This path is not available.'},
      });
      return;
    }

    this.setState({status: 'success'});

    window.setTimeout(() => {
      this.setState({status: null, formVisible: false, errors: {}});
    }, 2000);
  };
}

export default compose(
  graphql(
    gql`
      mutation UpdateSubdomainMutation($input: PracticeInput!) {
        updatePractice(input: $input) {
          practice {
            id
            subdomain
          }
          errors {
            path
            message
          }
        }
      }
    `,
  ),
)(SubdomainForm);
